module.exports = __webpack_public_path__ + "static/ulbLogo-542ee69a470f662fe8a45fde5eb351ef.png";